import { Component, OnInit } from '@angular/core';
import { IngredientService, Ingredient } from "app/services/ingredient.service";
import { CategoryService, Category } from 'app/services/category.service';
import { ColorShadeService, ColorShade } from '../../../services/color-shade.service';
import { TonalityService, Tonality } from '../../../services/tonality.service';
import { PigmentService, Pigment } from '../../../services/pigment.service';
import { Router, ActivatedRoute } from "@angular/router";
import { BaseComponent } from "app/components/base.component";
import * as _ from 'underscore';

declare var $: any;

@Component({
	selector: 'app-ingredients-export',
	templateUrl: './ingredients-export.component.html',
	styleUrls: ['./ingredients-export.component.css']
})
export class IngredientsExportComponent extends BaseComponent implements OnInit {
	ingredients: any;
	private allItemsOri: Ingredient[];
	public total_data_to_export: number = 0;
	private temp_cat = new Category();
	private temp_color_shade = new ColorShade();
	private temp_tonality = new Tonality();
	private temp_Pigment = new Pigment();
	constructor(
		private ingredientService: IngredientService,
		private categoryService: CategoryService,
		private colorShadeService: ColorShadeService,
		private tonalityService: TonalityService,
		private pigmentService: PigmentService,
	) {
		super();
	}

	ngOnInit() {
		this.ingredients = this.ingredientService.getIngredients().subscribe(ingredients => {
			this.ingredients = ingredients.sort((a, b) => {
				a.product_name = a.product_name || '';
				b.product_name = b.product_name || '';
				if (a.product_name == b.product_name) {
					return 0;
				}
				return a.product_name.toLowerCase() < b.product_name.toLowerCase() ? -1 : 1;
			})
			this.allItemsOri = _.clone(this.ingredients);
			this.total_data_to_export = this.allItemsOri.length;
		});
	}

	export_data() {
		var self = this;
		var to_export = "data:text/csv;charset=utf-8,";
		to_export += "SAP Code,Category,Subcategory,ABC Status,Product Name,Color Shade,Tonality,GIN,Description,Pigment,Halal Status,Product Status,Solubility,Format,Application Suggestion,Packaging Size,MOQ,Shelf Life,Lead Time,Selling Price,Spec Doc,TDS Doc,MSDS Doc,Halal Doc\n"
		this.allItemsOri.forEach(element => {
			// sap
			to_export += self._sap_code_format(element.sap_code) + ",";
			// category
			to_export += self._category_mapping(element.category_id) + ",";
			// sub category
			to_export += self._category_mapping(element.category_id) + ",";
			// abc status
			to_export += self._product_list_mapping(element.product_list) + ",";
			// product name
			to_export += self._name_format(element.product_name) + ",";
			// color shade
			to_export += self._color_shade_mapping(element.color_shade_id) + ",";
			// tonality
			to_export += self._tonality_mapping(element.tonality_id) + ",";
			// GIN 
			to_export += self._gin_format(element.gin) + ",";
			// description
			to_export += self._description_format(element.description) + ",";
			// Pigment
			to_export += self._pigment_mapping(element.pigment_id) + ",";
			// halal status
			to_export += self._halal_status_mapping(element.halal_status) + ",";
			// product stays
			to_export += self._product_status_mapping(element.product_status) + ",";
			// solubility
			to_export += self._solubility_format(element.solubility) + ",";
			// format
			to_export += self._format_mapping(element.format) + ",";
			// application suggestion
			to_export += self._application_suggestion_format(element.application_suggestion) + ",";
			// packagin size
			to_export += self._array_mapping(element.packaging_size) + ",";
			// MOQ
			to_export += self._array_mapping(element.moq) + ",";
			// shelf life
			to_export += self._shelf_life_mapping(element.shelf_life) + ",";
			// lead time
			to_export += self._lead_time_mapping(element.lead_time) + ",";
			// Selling price
			to_export += self._price_mapping(element.price) + ",";
			// Spec 
			to_export += element.doc_spec + ",";
			// TDS
			to_export += element.doc_TDS + ",";
			// MSDS
			to_export += element.doc_MSDS + ",";
			// HAlal
			to_export += element.doc_halal + "\n";
		});
		// to_export += $.csv.fromObjects(this.allItemsOri);
		var encodedUri = encodeURI(to_export);
		var link = document.createElement("a");
		link.setAttribute("href", encodedUri);
		var currentdate = new Date();
		var datetime = currentdate.getDate() + "-"
			+ (currentdate.getMonth() + 1) + "-"
			+ currentdate.getFullYear() + "-"
			+ currentdate.getHours() + "-"
			+ currentdate.getMinutes() + "-"
			+ currentdate.getSeconds();
		link.setAttribute("download", "product-export-" + datetime + ".csv");
		document.body.appendChild(link); // Required for FF

		link.click(); // This will download the data file named "my_data.csv".
	}

	export_data_new() {
		var self = this;
		var products = self.allItemsOri.sort((a, b) => {
			return a.category_id.localeCompare(b.category_id);
		});

		var csv = [];
		csv.push([
			'SAP Code',
			'Category',
			'Subcategory',
			'ABC Status',
			'Product Name',
			'Color Shade',
			'Tonality',
			'GIN',
			'Description',
			'Pigment',
			'Halal Status',
			'Product Status',
			'Solubility',
			'Format',
			'Application Suggestion',
			'Packaging Size',
			'MOQ',
			'Shelf Life',
			'Lead Time',
			'Selling Price',
			'Spec Doc',
			'TDS Doc',
			'MSDS Doc',
			'Halal Doc'
		]);
		products.forEach((element, index) => {
			csv.push([
				// sap
				element.$key,
				// category
				self._category_mapping(element.category_id),
				// sub category
				self._category_mapping(element.category_id),
				// abc status
				self._product_list_mapping(element.product_list),
				// product name
				self._name_format(element.product_name),
				// color shade
				self._color_shade_mapping(element.color_shade_id),
				// tonality
				self._tonality_mapping(element.tonality_id),
				// GIN 
				self._gin_format(element.gin),
				// description
				self._description_format(element.description),
				// Pigment
				self._pigment_mapping(element.pigment_id),
				// halal status
				self._halal_status_mapping(element.halal_status),
				// product stays
				self._product_status_mapping(element.product_status),
				// solubility
				self._solubility_format(element.solubility),
				// format
				self._format_mapping(element.format),
				// application suggestion
				self._application_suggestion_format(element.application_suggestion),
				// packagin size
				self._array_mapping(element.packaging_size),
				// MOQ
				self._array_mapping(element.moq),
				// shelf life
				self._shelf_life_mapping(element.shelf_life),
				// lead time
				self._lead_time_mapping(element.lead_time),
				// Selling price
				self._price_mapping(element.price),
				// Spec 
				element.doc_spec,
				// TDS
				element.doc_TDS,
				// MSDS
				element.doc_MSDS,
				// Halal
				element.doc_halal
			]);
		});

		var csv_string = 'data:text/csv;charset=utf-8,' + $.csv.fromArrays(csv);
		var encodedUri = encodeURI(csv_string);
		var link = document.createElement("a");
		link.setAttribute("href", encodedUri);
		var currentdate = new Date();
		var datetime = [
			currentdate.getDate(),
			(currentdate.getMonth() + 1),
			currentdate.getFullYear(),
			currentdate.getHours(),
			currentdate.getMinutes(),
			currentdate.getSeconds()
		].join('-');
		link.setAttribute("download", "product-export-" + datetime + ".csv");
		document.body.appendChild(link); // Required for FF

		link.click();
	}

	_product_list_mapping(to_format) {
		if (to_format) {
			return to_format.toUpperCase() + "-List";
		}
		return "";
	}
	_name_format(name) {
		if (name) {
			return name;
		}
		return "";
	}
	_color_shade_mapping(color_shade_id) {
		if (color_shade_id) {
			var to_return = "";
			this.colorShadeService.getColorShade(color_shade_id).subscribe(color_shade => {
				this.temp_color_shade = Object.assign(new ColorShade(), color_shade);
			});
			to_return = this.temp_color_shade.name;
			return to_return;
		}
		return "";
	}
	_tonality_mapping(tonality_id) {
		if (tonality_id) {
			var to_return = "";
			this.tonalityService.getTonality(tonality_id).subscribe(tonality => {
				this.temp_tonality = Object.assign(new Tonality(), tonality);
			});
			to_return = this.temp_tonality.name;
			return to_return;
		}
		return "";
	}
	_gin_format(gin) {
		if (gin) {
			return gin;
		}
		return "";
	}
	_description_format(description) {
		if (description) {
			return description;
		}
		return "";
	}
	_pigment_mapping(pigment_id) {
		if (pigment_id) {
			var to_return = "";
			this.pigmentService.getPigment(pigment_id).subscribe(pigment => {
				this.temp_Pigment = Object.assign(new Pigment(), pigment);
			});
			to_return = this.temp_Pigment.name;
			return to_return;
		}
		return "";
	}
	_sap_code_format(sap_code) {
		if (sap_code) {
			return '"' + sap_code + '"';
		}
		return "";
	}
	_category_mapping(cat_to_format) {
		if (cat_to_format) {
			var cat_to_return = "";
			this.categoryService.getCategory(cat_to_format).subscribe(category => {
				this.temp_cat = Object.assign(new Category(), category);
			});
			cat_to_return = this.temp_cat.name;
			return cat_to_return;
		}
		return "";
	}
	_halal_status_mapping(halal_status) {
		var the_value: string = "";
		switch (halal_status) {
			case "halal":
				the_value = "Halal";
				break;
			case "special-permit":
				the_value = "Special Permit";
				break;
			case "non-halal":
				the_value = "Non Halal";
				break;
			default:
				the_value = "";
				break;
		}
		return the_value;
	}

	_product_status_mapping(product_status) {
		var the_value: string = "";
		switch (product_status) {
			case "natural":
				the_value = "Natural";
				break;
			case "powder":
				the_value = "Powder";
				break;
			default:
				the_value = "";
				break;
		}
		return the_value;
	}

	_solubility_format(solubility) {
		if (solubility) {
			return solubility;
		}
		return "";
	}

	_format_mapping(format) {
		var the_value: string = "";
		switch (format) {
			case "liquid":
				the_value = "Liquid";
				break;
			case "powder":
				the_value = "Powder";
				break;
			case "durarome":
				the_value = "Durarome";
				break
			default:
				the_value = "";
				break;
		}
		return the_value;
	}
	_application_suggestion_format(application_suggestion) {
		if (application_suggestion) {
			return application_suggestion;
		}
		return "";
	}
	_shelf_life_mapping(shelf) {
		if (shelf) {
			return shelf;
		}
		return "";
	}

	_lead_time_mapping(lead_time) {
		if (lead_time) {
			return lead_time;
		}
	}

	_price_mapping(price) {
		if (price) {
			return price;
		}
	}

	_array_mapping(originaldata: any) {
		if (originaldata) {
			var to_return = originaldata.join(',');
			return to_return;
		}
		return "";
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/ingredient/ingredients-export/ingredients-export.component.ts